import { useDispatch } from 'react-redux';
import type { AppDispatch } from './store'; // Adjust the import path

export const useAppDispatch: () => AppDispatch = useDispatch;
